import React, { FC } from "react";
import ArticleWidget from "../ArticleWidget/ArticleWidget";
import PromoWidget from "../PromoWidget/PromoWidget";
import { IArticleWidgetProps } from "../ArticleWidget";
import { IPromoWidgetProps } from "../PromoWidget/PromoWidget.interface";
import { THeroBannerSlideType } from "./HeroBanner.interface";

export interface IHeroBannerSlideProps {
  slideType: THeroBannerSlideType;
  slideData: IArticleWidgetProps | IPromoWidgetProps;
}

const HeroBannerSlide: FC<IHeroBannerSlideProps> = ({
  slideType,
  slideData,
}) => {
  if (slideType === "ArticleWidget") {
    return <ArticleWidget {...(slideData as IArticleWidgetProps)} />;
  }
  return <PromoWidget {...(slideData as IPromoWidgetProps)} />;
};

export default HeroBannerSlide;
